import * as React from 'react';
import type { SVGProps } from './types';

const CirclesDecoration = React.forwardRef<SVGSVGElement, SVGProps>((props, forwardedRef) => {
  const { color = 'currentColor', size = 336, className, ...other } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 336 336"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      ref={forwardedRef}
      {...other}
    >
      <circle cx="168" cy="168" r="47.5" stroke={color} />
      <circle cx="168" cy="168" r="71.5" stroke={color} />
      <circle cx="168" cy="168" r="95.5" stroke={color} />
      <circle cx="168" cy="168" r="119.5" stroke={color} />
      <circle cx="168" cy="168" r="143.5" stroke={color} />
      <circle cx="168" cy="168" r="167.5" stroke={color} />
    </svg>
  );
});

export { CirclesDecoration };
